import { render, staticRenderFns } from "./rateios.vue?vue&type=template&id=17b9d9b6&"
import script from "./rateios.vue?vue&type=script&lang=js&"
export * from "./rateios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports